
import Typography from '../../../typography';
import IconButton from '../../../icon-button';
import Gutter from '../../../gutter';
import Divider from '../../../divider';
import Select from '../../../form/controls/components/select';
import {
  IconButtonProperty,
  IconButtonPropsEventType,
} from '../../../icon-button/enums';
import { IconType } from '../../../icon/enums';
import { GutterProperty } from '../../../gutter/enums';
import StylesMixin from '../../../../mixins/styles';
import { SelectProperty } from '../../../form/controls/components/select/enums';
import { InputFillType } from '../../../form/controls/shared/input/enums';
import {
  PAGINATION_ITEMS_PER_PAGE_OPTIONS,
  DEFAULT_ACTIVE_PAGE,
} from './constants';
import { ControlEventType } from '../../../form/controls/enums';
import GridPagination from './entities/GridPagination';

export default {
  name: 'GridPagination',
  components: {
    Divider,
    Select,
    IconButton,
    Gutter,
    Typography,
  },
  mixins: [StylesMixin],
  props: {
    pagination: {
      required: true,
      type: GridPagination,
    },
    itemsPerPageOptions: {
      default: () => PAGINATION_ITEMS_PER_PAGE_OPTIONS,
      type: Array,
    },
  },
  data() {
    return {
      InputFillType,
      IconType,
      IconButtonProperty,
      IconButtonPropsEventType,
      GutterProperty,
      ControlEventType,
      SelectProperty,
    };
  },
  computed: {
    statusText() {
      return `${this.pagination.firstIndexOnPage}-${this.pagination.lastIndexOnPage} of ${this.pagination.totalItems}`;
    },
    isLeftArrowDisabled() {
      return this.pagination.pageNumber === DEFAULT_ACTIVE_PAGE;
    },
    isRightArrowDisabled() {
      return this.pagination.pageNumber === this.pagination.pagesAmount;
    },
  },
  methods: {
    handleSelectChange(value) {
      this.pagination.setOptions({
        pageSize: value,
        pageNumber: DEFAULT_ACTIVE_PAGE,
      });
      this.emitChange();
    },
    handleLeftArrowButtonClick() {
      if (this.isLeftArrowDisabled) {
        return;
      }

      this.pagination.setPageNumber(this.pagination.pageNumber - 1);
      this.emitChange();
    },
    handleRightArrowButtonClick() {
      if (this.isRightArrowDisabled) {
        return;
      }

      this.pagination.setPageNumber(this.pagination.pageNumber + 1);
      this.emitChange();
    },
    emitChange() {
      this.$emit('change', this.pagination.options);
    },
  },
};
